import React, { useState } from 'react';
import { TabContainer } from 'assets/containers/AssetDetailView/styles';

const TabView = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].title);

  const onTabChange = key => {
    const tab = tabs.find(tab => tab.title === key);
    if (tab) {
      setActiveTab(tab.title);
    }
  };

  const items = tabs.map((tab) => ({
    key: tab.title,
    label: tab.title,
    children: tab.content,
  }));

  return (
    <TabContainer items={items} onChange={onTabChange} activeKey={activeTab} style={{overflow: 'visible'}} />
  );
};

export default TabView;
